import {forwardRef} from "react";
import {t} from "i18next";
import {createCopyLink, generateUUID2, getImagePathWithTheme, isInDraw, isInPageLibrary} from "@/utils";
import {updateCard} from "@model/card";
import {message, Tooltip} from "antd";
import {MAX_Z_INDEX} from "@/Const";

const TurnNewCard = forwardRef((props:{editor:any,onTurnCallback?:any}, ref) => {

    /**
     * 取选中的文本
     */
    const getSelectedText = ()=>{
        const {from,to} = props.editor.state.selection;
        const text = props.editor.state.doc.textBetween(from,to,'');
        return text;
    }
    /**
     * 转换为新卡片
     */
    const onTurnNewCard = async ()=>{
        //1.创建新卡片
        const item = {
            createTime:Date.now(),
            doc:'',
            id:generateUUID2(),
            name:getSelectedText(),
            tags:[],
            type:'card',
            updateTime:Date.now()
        }
        await updateCard(item);
        const szLink = createCopyLink('library',item.id,'card',null,null,null,false)
        //2.添加链接
        props.editor.commands.setLink({href: szLink, target: '_blank'})
        setTimeout(() => {
            window.hookATags();
        }, 600)
        if (isInDraw()){
            window.showMessageTip(t("NewCardCreated"),t("Add to board"),"addToProject",()=>{
                if (window.onInsertNote){
                    window.onInsertNote(item);
                    window.closeMessageTip();
                }
            });
        }else{
            message.info(t("NewCardCreated"));
            if (isInPageLibrary()){
                //刷新列表
                window.globalRefreshList('refreshLibraryList_');
            }
        }

        if (props.onTurnCallback){
            props.onTurnCallback();
        }
    }

    return(
        <Tooltip arrow={false} zIndex={MAX_Z_INDEX} title={t("TurnToNewCard")}>
            <div className={'flex-center'} onClick={onTurnNewCard}>
                {/*<span style={{color:'var(--primary-color)',display:'block',whiteSpace:'nowrap'}}>{t("New card")}</span>*/}
                <img className={'img-20'} src={getImagePathWithTheme('turn_to_new_card')}/>
            </div>
        </Tooltip>

    )
})

export default TurnNewCard;















